import { animate, animateChild, state, style, transition, trigger } from "@angular/animations";

export const fadeOp = trigger('fadeOp', [
    transition(':enter', [
        style({ opacity: 0 }),
        animate('250ms', style({ opacity: 1 })),
    ]),
    transition(':leave', animate('250ms', style({ opacity: 0 })))
]);

export const slide = trigger('slide', [
    transition(':enter', [
        style({ transform: 'translateX(-100px)', opacity: 0 }),
        animate('250ms', style({ transform: 'translateX(0px)', opacity: 1 })),
    ]),
    // transition(':leave', animate('250ms', style({ transform: 'translateX(100px)', opacity: 0 }))),
])

export const fadeHeight = trigger('fadeHeight', [
    transition(':enter', [
        style({ opacity: 0, height: 0, overflow: 'hidden' }),
        animate('200ms', style({ opacity: 1, height: '*' })),
    ]),
    transition(':leave', animate('200ms', style({ opacity: 0, height: 0 })))
]);

export const fadeOpInOut = trigger('fadeOpInOut', [
    transition(':enter', [
        style({ opacity: 0, height: 0 }),
        animate('250ms', style({ opacity: 1, height: '*' })),
    ]),
    transition(':leave', animate('250ms', style({ opacity: 0, height: 0 })))
]);

export const fade = trigger('fade', [
    transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('150ms', style({ height: '*', opacity: 1 }))
    ]),
    transition(':leave', animate('150ms', style({ height: 0, opacity: 0 })))
]);

export const page = trigger('pageAnim', [
    transition('unauthorized => authorized', [
        style({ transform: 'translateX(100px)', opacity: 0, position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }),
        animate('250ms ease-in', style({
            transform: 'translateX(0px)',
            opacity: 1
        }))
    ]),
    transition('authorized => unauthorized', [
        style({ transform: 'translateX(-100px)', opacity: 0, position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }),
        animate('250ms ease-in', style({
            transform: 'translateX(0px)',
            opacity: 1
        }))
    ])
]);

export const oppage = trigger('oppage', [
    transition('* <=> *', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({
            opacity: 1
        }))
    ])
]);

// export const fadePage = trigger('fadePage', [
//     transition('* => *', [
//         style({ opacity: 0 }),
//         animate('250ms', style({ opacity: 1 }))
//     ]),
//     transition('* ', animate('250ms', style({ opacity: 0 })))
// ])